module.exports = __webpack_public_path__ + "img/pin_c_black.bdf71cad.svg";